import { Directive, ElementRef, Input } from "@angular/core";
export var FocusDirective = (function () {
    function FocusDirective(el) {
        this.el = el;
    }
    FocusDirective.prototype.ngAfterViewInit = function () {
        if (this.value === "0") {
            return;
        }
        this.el.nativeElement.focus();
    };
    FocusDirective.decorators = [
        { type: Directive, args: [{
                    selector: "[ngxfocus]"
                },] },
    ];
    FocusDirective.ctorParameters = [
        { type: ElementRef, },
    ];
    FocusDirective.propDecorators = {
        'value': [{ type: Input, args: ["ngxfocus",] },],
    };
    return FocusDirective;
}());
//# sourceMappingURL=ngx-my-date-picker.focus.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/directives/ngx-my-date-picker.focus.directive.js
// module id = 427
// module chunks = 4